import { render, staticRenderFns } from "./fields-design-form.vue?vue&type=template&id=3634d570"
import script from "./fields-design-form.vue?vue&type=script&lang=js"
export * from "./fields-design-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports